import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Grid, Header, Loader, Segment } from 'semantic-ui-react';
import { RouteComponentProps } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

// @ts-ignore
import SharedEventEndDate from './components/SharedEventEndDate';
import SharedEventEndDateHeader from './components/SharedEventEndDateHeader';
// @ts-ignore
import SharedEventEntityPathNames from './components/SharedEventEntityPathNames';
import SharedEventEntityPathNamesHeader from './components/SharedEventEntityPathNamesHeader';
// @ts-ignore
import SharedEventGroupName from './components/SharedEventGroupName';
import SharedEventGroupNameHeader from './components/SharedEventGroupNameHeader';
// @ts-ignore
import SharedEventInstructions from './components/SharedEventInstructions';
// @ts-ignore
import SharedEventRequest from './components/SharedEventRequest';
// @ts-ignore
import SharedEventStartDate from './components/SharedEventStartDate';
import SharedEventStartDateHeader from './components/SharedEventStartDateHeader';

import './styles.scss';

const { REACT_APP_PROJECT_NAME } = process.env;

interface Params {
    eventUuid: string;
}

type Props = Pick<RouteComponentProps<Params>, 'match'>;

class SharedEvent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            match: {
                params: { eventUuid }
            }
        } = this.props;

        return (
            <ErrorBoundary
                namespace="SharedEvent"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Helmet>
                    <title>Shared Job - {REACT_APP_PROJECT_NAME}</title>
                </Helmet>
                <SharedEventRequest eventUuid={eventUuid} />
                <PageWrapper>
                    <LoadingGate
                        namespace="SHARED_EVENT_LOAD"
                        LoadingComponent={<Loader active inline="centered" />}
                    >
                        <ErrorGate namespace="SHARED_EVENT_LOAD">
                            <Container text>
                                <Grid centered>
                                    <Grid.Row>
                                        <Grid.Column
                                            mobile={16}
                                            tablet={8}
                                            computer={8}
                                        >
                                            <Segment class="shared-event-print">
                                                <Header>Details</Header>
                                                <SharedEventEntityPathNamesHeader />
                                                <SharedEventEntityPathNames />
                                                <SharedEventGroupNameHeader />
                                                <SharedEventGroupName />
                                                <SharedEventStartDateHeader />
                                                <SharedEventStartDate />
                                                <SharedEventEndDateHeader />
                                                <SharedEventEndDate />
                                                <SharedEventInstructions />
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Container>
                        </ErrorGate>
                    </LoadingGate>
                </PageWrapper>
            </ErrorBoundary>
        );
    }
}

export default SharedEvent;
